import { AnimaliaDetailTaxonomyStepDTO } from '../../../../application/mappers/AnimaliaDetailMapper';
import { buildAnimaliaTaxonomyCanonicalRoute } from '../../../../application/taxonomy/AnimaliaNavigableTaxonomy';
import { animaliaDetailDesignTokens } from '../shared/animalia-detail-design-tokens';

export class MvAnimaliaDetailTaxonomy extends HTMLElement {
  private steps: ReadonlyArray<AnimaliaDetailTaxonomyStepDTO> = [];

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  setSteps(steps: ReadonlyArray<AnimaliaDetailTaxonomyStepDTO>): void {
    this.steps = [...steps];
    this.render();
  }

  connectedCallback(): void {
    this.render();
  }

  private render(): void {
    if (!this.shadowRoot) {
      return;
    }

    this.shadowRoot.innerHTML = `
      <style>
        ${animaliaDetailDesignTokens}

        h2 {
          margin: 8px 0 0;
          color: #31463d;
          font-size: clamp(1.8rem, 2.6vw, 2.8rem);
          font-family: Georgia, 'Times New Roman', serif;
        }

        .taxonomy-rail {
          display: grid;
          gap: 12px;
        }

        .taxonomy-step {
          position: relative;
          padding: 18px 20px;
        }

        .taxonomy-link {
          display: block;
          color: inherit;
          text-decoration: none;
        }

        .taxonomy-link:hover .taxonomy-step,
        .taxonomy-link:focus-visible .taxonomy-step {
          background: rgba(240, 234, 223, 0.82);
          outline: none;
        }

        strong {
          display: block;
          margin-top: 8px;
          color: #31463d;
          font-size: 1.14rem;
        }

        .step-line {
          position: absolute;
          right: 20px;
          top: 50%;
          width: 52px;
          height: 1px;
          background: rgba(49, 70, 61, 0.18);
        }

      </style>

      <section>
        <header>
          <p class="section-kicker">Jerarquia</p>
          <h2>Clasificacion cientifica</h2>
        </header>
        <div class="taxonomy-rail">
          ${this.steps
            .map(
              (step) => `
                <a
                  class="taxonomy-link"
                  href="${this.escapeAttribute(
                    buildAnimaliaTaxonomyCanonicalRoute(step.filterKey, step.value),
                  )}"
                  aria-label="Filtrar por ${this.escapeAttribute(step.label)} ${this.escapeAttribute(step.value)}"
                >
                  <article class="taxonomy-step editorial-panel">
                    <p class="field-label">${this.escapeHtml(step.label)}</p>
                    <strong>${this.escapeHtml(step.value)}</strong>
                    <span class="step-line"></span>
                  </article>
                </a>
              `,
            )
            .join('')}
        </div>
      </section>
    `;
  }

  private escapeHtml(value: string): string {
    return value
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }

  private escapeAttribute(value: string): string {
    return this.escapeHtml(value);
  }
}

if (!customElements.get('mv-animalia-detail-taxonomy')) {
  customElements.define('mv-animalia-detail-taxonomy', MvAnimaliaDetailTaxonomy);
}
